import * as types from "./constants";

const initialState = {
  courses: [],
  assignedCourses: [],
  coursesLoading: false,
  parentUrl: null,
};

const allCoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PARENT_URL:
      return {
        ...state,
        parentUrl: action.parentUrl,
      };
    case types.SET_COURSES:
      return {
        ...state,
        courses: action.courses,
      };
    case types.SET_LOADING:
      return {
        ...state,
        coursesLoading: action.loading,
      };
    case types.SET_ASSIGNED_COURSES:
      return {
        ...state,
        assignedCourses: action.courses,
      };
    case types.SET_ASSIGN_COURSE:
      return {
        ...state,
        assignedCourses: [...state.assignedCourses, action.course],
      };
    case types.SET_UNASSIGN_COURSE:
      return {
        ...state,
        assignedCourses: state.assignedCourses.filter(
          (item) => item.course_id !== action.course
        ),
      };
    default:
      return state;
  }
};

export default allCoursesReducer;
